import axios from 'axios';
import config from '../config/config';
import { getAuthHeaders } from '../utils/authUtils'; // Import the utility function

export const fetchProject = async (projectId) => {
  const response = await axios.get(`${config.apiBaseUrl}/api/projects/${projectId}`, {
    headers: getAuthHeaders(),
  });
  console.log('Proj Details:',response.data);
  const projectData = response.data;
  projectData.start_date = projectData.start_date ? new Date(projectData.start_date) : null;
  projectData.planned_completion_date = projectData.planned_completion_date ? new Date(projectData.planned_completion_date) : null;
  projectData.actual_completion_date = projectData.actual_completion_date ? new Date(projectData.actual_completion_date) : null;
  return projectData;
};

export const fetchCompanies = async () => {
  const response = await axios.get(`${config.apiBaseUrl}/api/companies`, {
    headers: getAuthHeaders(),
  });
  
  return response.data;
};

export const fetchLocations = async () => {
  const response = await axios.get(`${config.apiBaseUrl}/api/locations`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const fetchProjectTypes = async () => {
  const response = await axios.get(`${config.apiBaseUrl}/api/project-types`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const saveProject = async (projectId, project) => {
  const headers = getAuthHeaders();
  if (projectId && projectId !== 'new') {
    await axios.put(`${config.apiBaseUrl}/api/projects/${projectId}`, project, { headers });
  } else {
    const response = await axios.post(`${config.apiBaseUrl}/api/projects`, project, { headers });
    return response.data.project_id;
  }
};

export const deleteProject = async (projectId) => {
  await axios.delete(`${config.apiBaseUrl}/api/projects/${projectId}`, {
    headers: getAuthHeaders(),
  });
};

export const fetchProjectDocuments = async (projectId) => {
  try {
    const response = await axios.get(`${config.apiBaseUrl}/api/pdocs`, {
      params: { project_id: projectId },
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching project documents:', error);
    throw error;
  }
};

export const uploadProjectDocument = async (projectId, file, documentName, description, departmentId) => {
  const formData = new FormData();
  formData.append('project_id', projectId);
  formData.append('file', file);
  formData.append('document_name', documentName);
  formData.append('description', description);
  formData.append('department_id', departmentId); // Include department_id in the payload

  try {
    const response = await axios.post(`${config.apiBaseUrl}/api/pdocs`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...getAuthHeaders(),
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading project document:', error);
    throw error;
  }
};

export const deleteProjectDocument = async (documentId) => {
  const response = await axios.delete(`${config.apiBaseUrl}/api/pdocs/${documentId}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};